module.exports = __webpack_public_path__ + "pnce-icon.1faebf65b2875e753f1d.svg";


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/img/icon/pnce-icon.svg
// module id = ../../../../../src/img/icon/pnce-icon.svg
// module chunks = styles